// extracted by mini-css-extract-plugin
export default {"layout":"AppLayout_layout__gqrC8","main":"AppLayout_main__Gn9gV","content":"AppLayout_content__4jmGq"};